
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
// WARNING: Using the Service Key on the client side bypasses Row Level Security (RLS)
// and exposes your database to full administrative access if this key leaks.
// Only use this in trusted, internal environments or for testing.
const supabaseKey = process.env.REACT_APP_SUPABASE_SERVICE_KEY || process.env.REACT_APP_SUPABASE_KEY;

export const supabase = createClient(supabaseUrl, supabaseKey);
